var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vh-chat-editorArea"},[_c('div',{staticClass:"chat-tips"},[_c('img',{attrs:{"src":require("./chat-tips@2x.png"),"alt":""}})])])
}]

export { render, staticRenderFns }